"use strict";

var PropTypes = require("prop-types");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class MyRecurringHeaderEditUseOnDaySelectorComponent extends React.Component {
	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				hideEmptyOption={!this.props.isDesignMode}
				config={this.props.useOnDays} /*Needs to be useOnDays because the UseOnDaySElectorPropertyMap is hard-coded to this*/
				wizard={window.ProjectStore.get("wizardUseOnDays")}
				wizardValuesKey="allowedUseOnDays"
				configKey="availableUseOnDays"
				reactComponentCategory="MyRecurringHeaderEditUseOnDaySelector"
				reactComponentName="MyRecurringHeaderEditUseOnDaySelector"
				selectClassName="use-on-day-selector"
				optionsClassName="availableUseOnDay"
				selectNameAttribute="useOnDay"
			/>
		);
	}
}

MyRecurringHeaderEditUseOnDaySelectorComponent.propTypes = {
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	reactComponentCategory: PropTypes.string,
	required: PropTypes.bool,
	theme: PropTypes.string,
	useOnDays: PropTypes.object
};

module.exports = MyRecurringHeaderEditUseOnDaySelectorComponent;
